import { motion } from "framer-motion";
import { Wrench, Snowflake, Paintbrush, CircleDot, BatteryCharging, Droplets } from "lucide-react";
import { trackServiceCardClick } from "@/lib/pixel";

const scrollTo = (id) =>
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

const SERVICES = [
  { icon: Wrench, title: "Periodic Service & Maintenance", desc: "Manufacturer-schedule servicing with genuine filters, oils & parts." },
  { icon: Snowflake, title: "AC Service & Repair", desc: "Gas top-up, compressor work, cooling diagnostics — all brands." },
  { icon: Paintbrush, title: "Denting & Painting", desc: "Factory-finish paint booth, panel repair & full-body restoration." },
  { icon: CircleDot, title: "Wheel Alignment & Balancing", desc: "Computerized alignment for a straight, vibration-free drive." },
  { icon: BatteryCharging, title: "Battery, Brakes & Suspension", desc: "Critical safety systems — genuine replacements only." },
  { icon: Droplets, title: "Car Wash & Detailing", desc: "Deep interior cleaning, polishing, ceramic & PPF options." },
];

export default function Services() {
  return (
    <section id="services" className="py-16 sm:py-28 px-5 lg:px-8 bg-white" data-testid="services-section">
      <div className="max-w-7xl mx-auto">
        <p className="text-xs uppercase tracking-[0.25em] text-[#FF5A00] font-bold mb-3">What We Do</p>
        <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-[#0A0A0A]">
          Every Service. <span className="text-[#FF5A00]">Every Brand.</span>
        </h2>
        <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {SERVICES.map(({ icon: Icon, title, desc }, i) => (
            <motion.div
              key={title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.06 }}
              onClick={() => { trackServiceCardClick(title); scrollTo("callback"); }}
              className="bg-white border border-[#E4E4E7] rounded-sm p-7 hover:border-[#FF5A00] hover:-translate-y-1 transition-all duration-200 group cursor-pointer"
              data-testid={`service-card-${i}`}
            >
              <div className="flex items-start justify-between">
                <Icon className="w-8 h-8 text-[#FF5A00]" />
                <span className="text-[10px] uppercase tracking-wider font-bold bg-[#F5F5F7] text-[#0A0A0A] rounded-full px-3 py-1">
                  Genuine Parts Only
                </span>
              </div>
              <h3 className="mt-5 text-lg font-semibold text-[#0A0A0A]">{title}</h3>
              <p className="mt-2 text-sm text-[#52525B] leading-relaxed">{desc}</p>
            </motion.div>
          ))}
        </div>
        <p className="mt-6 text-sm text-[#52525B]">
          🚗 Free pickup &amp; drop within 10 km of Ranigunj.
        </p>
      </div>
    </section>
  );
}
